import { render } from "./ColorInnerImage.vue?vue&type=template&id=280a65c4"
import script from "./ColorInnerImage.vue?vue&type=script&lang=js"
export * from "./ColorInnerImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__